export type PlanKey = 'ticket10' | 'standard' | 'premium'

export interface PlansSectionProps {
  selectedPlan: PlanKey
  onChange: (plan: PlanKey) => void
  compact?: boolean
}

export default function PlansSection({ selectedPlan, onChange, compact = false }: PlansSectionProps) {
  const outerClasses = compact
    ? 'mx-auto w-full'
    : 'bg-[#F8F8F8] mx-auto max-w-6xl px-6 pb-4 pt-10 md:pb-24'

  const planButtonClass = (plan: PlanKey) =>
    `w-full bg-white rounded-2xl px-5 py-2.5 md:px-6 md:py-3 h-[70px] md:h-[96px] flex items-center justify-between ring-inset ${
      selectedPlan === plan
        ? 'ring-1 ring-[#06C755] shadow-[0_2px_8px_rgba(6,199,85,0.18),0_8px_16px_rgba(6,199,85,0.10)]'
        : 'ring-0 border border-gray-200 shadow-md'
    }`

  const radioClass = (plan: PlanKey) =>
    `inline-block w-8 h-8 md:w-10 md:h-10 rounded-full ${
      selectedPlan === plan ? 'border-4 border-[#06C755] bg-white' : 'bg-gray-300'
    }`

  return (
    <section className={outerClasses}>
      <div className="space-y-4">
        {/* 10回チケット */}
        <button type="button" onClick={() => onChange('ticket10')} className={planButtonClass('ticket10')}>
          <div className="flex items-center gap-3 md:gap-4">
            <span className={radioClass('ticket10')}></span>
            <span className="flex flex-col items-start text-left">
              <span className="text-[20px] md:text-[24px] font-medium text-black leading-tight">10回チケット</span>
              <span className="text-xs md:text-sm text-gray-500">スチル10枚（期限なし）</span>
            </span>
          </div>
          <div className="text-right">
            <div className="text-black font-medium leading-none">
              <span className="mx-1 text-[24px] md:text-[34px] font-medium">480</span>
              <span className="align-baseline text-sm md:text-base">円</span>
            </div>
          </div>
        </button>

        {/* 月額スタンダード */}
        <button type="button" onClick={() => onChange('standard')} className={planButtonClass('standard')}>
          <div className="flex items-center gap-3 md:gap-4">
            <span className={radioClass('standard')}></span>
            <span className="flex flex-col items-start text-left">
              <span className="text-[20px] md:text-[24px] font-medium text-black leading-tight">月額スタンダード</span>
              <span className="text-xs md:text-sm text-gray-500">毎月スチル20枚・ミラー1回</span>
            </span>
          </div>
          <div className="text-right">
            <div className="text-black font-medium leading-none">
              <span className="align-baseline text-sm md:text-base">月額</span>
              <span className="mx-1 text-[24px] md:text-[34px] font-medium">980</span>
              <span className="align-baseline text-sm md:text-base">円</span>
            </div>
          </div>
        </button>

        {/* 月額プレミアム */}
        <button type="button" onClick={() => onChange('premium')} className={planButtonClass('premium')}>
          <div className="flex items-center gap-3 md:gap-4">
            <span className={radioClass('premium')}></span>
            <span className="flex flex-col items-start text-left">
              <span className="text-[20px] md:text-[24px] font-medium text-black leading-tight">月額プレミアム</span>
              <span className="text-xs md:text-sm text-gray-500">毎月スチル20枚・ミラー5回</span>
            </span>
          </div>
          <div className="text-right">
            <div className="text-black font-medium leading-none">
              <span className="align-baseline text-sm md:text-base">月額</span>
              <span className="mx-1 text-[24px] md:text-[34px] font-medium">1,480</span>
              <span className="align-baseline text-sm md:text-base">円</span>
            </div>
          </div>
        </button>
      </div>
    </section>
  )
}
